import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import { Col, Form, Card, Button, Table } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { FaSearch } from 'react-icons/fa';
import { FiSave } from 'react-icons/fi';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';
import * as api from '~/Services/Service';
import * as constants from '~/constant';
import AuthStorage from '~/Utils/AuthStorage';
import Header from '~/Components/Header/Header';
import Loading from '~/Components/Loading';
import { Selector } from '~/Components/Prospectos/ProspectoDetalhes/Pesquisa/Form';
import SelectGerenteCorretor from '~/Components/GerentesCorretores/SelectGerenteCorretor';

const ACOES_MASSA = {
  ALTERAR_ETAPA: 1,
  ALTERAR_GESTOR_CAV: 2,
  ALTERAR_CORRETOR_ESPECIFICO: 3,
  ALTERAR_CORRETOR_ROLETA: 4,
  ATRIBUIR_INTERESSE: 5,
  INSERIR_BOLSAO: 6,
  REMOVER_BOLSAO: 7,
  DESASSOCIAR_IMOB_CORRETOR: 8,
  DESASSOCIAR_GESTOR_CAV: 9,
  ATRIBUIR_SETCLUB: 10,
  REMOVER_SETCLUB: 11,
};

const ACOES_OPTIONS = [
  { value: ACOES_MASSA.ALTERAR_ETAPA, label: 'Alterar Etapa' },
  { value: ACOES_MASSA.ALTERAR_GESTOR_CAV, label: 'Alterar Gestor CAV' },
  { value: ACOES_MASSA.ALTERAR_CORRETOR_ESPECIFICO, label: 'Alterar Imobiliaria/Corretor' },
  { value: ACOES_MASSA.ALTERAR_CORRETOR_ROLETA, label: 'Enviar para Fila de Distribuicao' },
  { value: ACOES_MASSA.ATRIBUIR_INTERESSE, label: 'Atribuir Interesse (Empreendimento)' },
  { value: ACOES_MASSA.INSERIR_BOLSAO, label: 'Inserir no Bolsao' },
  { value: ACOES_MASSA.REMOVER_BOLSAO, label: 'Remover do Bolsao' },
  { value: ACOES_MASSA.DESASSOCIAR_IMOB_CORRETOR, label: 'Desassociar Imobiliaria/Corretor' },
  { value: ACOES_MASSA.DESASSOCIAR_GESTOR_CAV, label: 'Desassociar Gestor CAV' },
  { value: ACOES_MASSA.ATRIBUIR_SETCLUB, label: 'Atribuir SetClube' },
  { value: ACOES_MASSA.REMOVER_SETCLUB, label: 'Remover SetClube' },
];

const ACOES_SETCLUB = [
  ACOES_MASSA.ATRIBUIR_SETCLUB,
  ACOES_MASSA.REMOVER_SETCLUB,
];

const ACOES_SETCLUB_OPTIONS = ACOES_OPTIONS.filter(option =>
  ACOES_SETCLUB.includes(option.value)
);

class AtribuirProspectos extends Component {
  state = {
    prospectos: null,
    acaoSelecionada: null,
    filasDistribuicao: [],
    loadingFilas: false,
  };

  componentDidMount() {
    if (this.props.codigo_prospecto) {
      this.buscarProspectoPorCodigo();
    } else if (
      this.props.codigosProspectos &&
      this.props.codigosProspectos.length > 0
    ) {
      this.buscarProspectosPorCodigos();
    }
  }

  buscarProspectoPorCodigo = async () => {
    const { codigo_prospecto } = this.props;

    let filtro = {
      codigo_familia: null,
      codigos_prospectos: [codigo_prospecto],
    };

    try {
      let prospectos = await api.buscarListaAtribuirProspectos(filtro);
      this.setState({ prospectos });
    } catch (err) {
      if (AuthStorage.isADM) {
        toast.warn('Prospecto(s) não encontrado(s).');
      } else
        toast.warn(
          'Prospecto(s) não encontrado(s) ou o(s) mesmo(s) não tem vínculo(s) que pertença(m) à você.'
        );
    }
  };


  buscarFilasDistribuicao = async (codigoEmpreendimento) => {
    if (!codigoEmpreendimento) {
      this.setState({ filasDistribuicao: [] });
      return;
    }

    this.setState({ loadingFilas: true });
    try {
      const filas = await api.buscarFilasDistribuicao(codigoEmpreendimento);
      this.setState({
        filasDistribuicao: filas.map(f => ({
          value: f.codigo,
          label: f.descricao,
        }))
      });
    } catch (err) {
      toast.warn('Erro ao buscar filas de distribuicao.');
      this.setState({ filasDistribuicao: [] });
    } finally {
      this.setState({ loadingFilas: false });
    }
  };

  buscarProspectosPorCodigos = async () => {
    if (this.props.modoEtapa) return;

    const { codigosProspectos } = this.props;

    let filtro = {
      codigo_familia: null,
      codigos_prospectos: codigosProspectos,
    };

    try {
      let prospectos = await api.buscarListaAtribuirProspectos(filtro);
      this.setState({ prospectos });
    } catch (err) {
      toast.warn('Erro ao buscar prospectos selecionados.');
    }
  };

  onClickNovaBusca = () => {
    this.setState({
      prospectos: null,
    });
  };

  atribuirEtapaEmMassa = async (prospectos, etapa, justificativa) => {
    const response = await api.atribuicaoEtapaEmMassa({
      prospectos: prospectos,
      etapa: etapa,
      justificativa: justificativa,
    });
    return response;
  };

  atribuirGestorCAVEmMassa = async (prospectos, gestorCAV, justificativa) => {
    const response = await api.atribuicaoAtendenteCavEmMassa({
      prospectos: [...new Set(prospectos.map(item => item.codigo_prospecto))],
      codigo_atendente_cav: gestorCAV,
      justificativa: justificativa,
    });
    return response;
  };

  isAcaoSetclub = acao => ACOES_SETCLUB.includes(acao);

  atribuirProspectos = async (
    {
      acao,
      codigo_corretor,
      codigo_gerente,
      codigo_atendente_cav,
      codigo_etapa,
      justificativa,
      vinculos,
    },
    { setSubmitting }
  ) => {
    if (this.props.modoEtapa) {
      if (!codigo_etapa && !codigo_atendente_cav) {
        toast.warn('Selecione uma etapa ou um gestor CAV');
        setSubmitting(false);
        return;
      }

      const justificativaFinal =
        this.props.justificativaPadrao || justificativa;

      if (!justificativaFinal || justificativaFinal.trim() === '') {
        toast.warn('Informe uma justificativa');
        setSubmitting(false);
        return;
      }

      try {
        if (codigo_etapa) {
          const responseAtribuicaoEtapas = await this.atribuirEtapaEmMassa(
            this.props.codigosProspectos,
            codigo_etapa,
            justificativaFinal
          );
          if (responseAtribuicaoEtapas) {
            toast.info(responseAtribuicaoEtapas.message);
          }
        }
        if (codigo_atendente_cav) {
          const responseAtribuicaoAtendenteCAV = await this.atribuirGestorCAVEmMassa(
            this.props.codigosProspectos,
            codigo_atendente_cav,
            justificativaFinal
          );
          if (responseAtribuicaoAtendenteCAV) {
            toast.info(responseAtribuicaoAtendenteCAV.message);
          }
        }
        this.props.onSuccess();
      } catch (error) {
        toast.error(error.message);
      }

      setSubmitting(false);
      return;
    }

    if (this.props.modoSimplificado) {
      if (!codigo_atendente_cav) {
        toast.warn('Selecione um atendente CAV');
        setSubmitting(false);
        return;
      }

      await api.atribuicaoAtendenteCavEmMassa({
        prospectos: this.props.codigosProspectos,
        codigo_atendente_cav: codigo_atendente_cav,
      });

      this.props.onSuccess();
      toast.success('Gestor atribuído com sucesso.');

      return;
    }

    const vinculosSelecionados = vinculos || [];
    const justificativaFinal = this.props.justificativaPadrao || justificativa;

    if (this.isAcaoSetclub(acao)) {
      if (vinculosSelecionados.length === 0) {
        toast.warn('Selecione ao menos um prospecto');
        setSubmitting(false);
        return;
      }

      if (!justificativaFinal || justificativaFinal.trim() === '') {
        toast.warn('Informe uma justificativa');
        setSubmitting(false);
        return;
      }

      const codigosProspectos = [
        ...new Set(
          vinculosSelecionados.map(item => Number(item.split('|')[0]))
        ),
      ];

      try {
        const request = {
          codigos_prospectos: codigosProspectos,
          justificativa: justificativaFinal,
        };

        const response =
          acao === ACOES_MASSA.ATRIBUIR_SETCLUB
            ? await api.atribuirSetclubEmMassa(request)
            : await api.removerSetclubEmMassa(request);

        toast.success(
          response && response.message
            ? response.message
            : 'SetClube atualizado com sucesso!',
          { position: 'top-right' }
        );
        this.setState({ prospectos: null });

        if (this.props.onSuccess) {
          this.props.onSuccess();
        }
      } catch (error) {
        toast.warn(
          error && error.message
            ? error.message
            : 'Erro ao atualizar SetClube dos prospectos.',
          { position: 'top-right' }
        );
      }

      setSubmitting(false);
      return;
    }

    vinculos = vinculosSelecionados.map(item => {
      const [codigo_prospecto, codigo_familia] = item.split('|');

      return {
        codigo_prospecto: Number(codigo_prospecto),
        codigo_familia: Number(codigo_familia),
      };
    });

    let filtro = {
      codigo_corretor,
      codigo_gerente,
      justificativa: justificativaFinal,
      vinculos,
    };

    try {
      await api.atribuirProspectos(filtro);
      toast.success('Prospectos atribuídos com sucesso!', {
        position: 'top-right',
      });
      this.setState({ prospectos: null });

      if (this.props.onSuccess) {
        this.props.onSuccess();
      }
    } catch (error) {
      toast.warn('Erro ao atribuir prospectos, tente novamente mais tarde', {
        position: 'top-right',
      });
    }

    setSubmitting(false);
  };

  buscarProspectos = async (
    { codigo_empreendimento, codigos_prospectos },
    { setSubmitting }
  ) => {
    let filtro = {
      codigo_familia: codigo_empreendimento,
      codigos_prospectos: codigos_prospectos
        .replace(/(\d*)\D+/g, '$1,')
        .split(',')
        .map(Number),
    };
    try {
      let prospectos = await api.buscarListaAtribuirProspectos(filtro);
      this.setState({ prospectos });
      setSubmitting(false);
    } catch (err) {
      if (AuthStorage.isADM) {
        toast.warn('Prospecto(s) não encontrado(s).');
      } else
        toast.warn(
          'Prospecto(s) não encontrado(s) ou o(s) mesmo(s) não tem vínculo(s) que pertença(m) à você.'
        );
    }
    setSubmitting(false);
  };

  buildValueEmpreendimento = codigo => {
    return codigo
      ? {
        value: parseInt(codigo),
        label: this.props.empreendimentos.byId[codigo].descricao,
      }
      : { value: '', label: 'Todos empreendimentos' };
  };

  selecionaTodosProspectos = (vinculos, prospectos) => {
    if (vinculos && vinculos.length > 0) return [];

    return prospectos.map(
      prospecto => `${prospecto.codigo_prospecto}|${prospecto.codigo_familia}`
    );
  };

  render() {
    const { prospectos } = this.state;
    const {
      empreendimentos,
      isLoadingOptions,
      codigo_prospecto,
      codigosProspectos,
      justificativaPadrao,
      hideHeader,
      modoSimplificado,
      modoEtapa,
      gestoresDisponiveis,
      etapasDisponiveis,
    } = this.props;

    const podeGerenciarSetclub = AuthStorage.temCaracteristica(
      constants.CARACTERISTICA_GERENCIAR_SETCLUB
    );

    const optionsEmpreendimentos = [
      { value: '', label: 'Todos empreendimentos' },
      ...empreendimentos.sort.map(item => ({
        value: item.codigo,
        label: item.descricao,
      })),
    ];

    if (modoEtapa && codigosProspectos) {
      return (
        <Formik
          onSubmit={this.atribuirProspectos}
          initialValues={{
            codigo_etapa: '',
            codigo_atendente_cav: '',
            justificativa: justificativaPadrao || '',
          }}
        >
          {({
            handleSubmit,
            values,
            handleChange,
            setFieldValue,
            isSubmitting,
          }) => (
            <Col>
              <Card>
                <Card.Body>
                  <Form onSubmit={handleSubmit}>
                    <Form.Group>
                      <Form.Label>Etapa</Form.Label>
                      <Selector
                        noOptionsMessage={() => 'Nenhuma etapa encontrada'}
                        placeholder="Selecione uma etapa..."
                        options={etapasDisponiveis || []}
                        onChange={option => {
                          setFieldValue(
                            'codigo_etapa',
                            option ? option.value : ''
                          );
                        }}
                        name="codigo_etapa"
                        isLoading={
                          !etapasDisponiveis || etapasDisponiveis.length === 0
                        }
                        value={
                          etapasDisponiveis.find(
                            e => e.value === values.codigo_etapa
                          ) || null
                        }
                        isClearable
                        isDisabled={isSubmitting}
                        styles={customStyles}
                        components={{ DropdownIndicator }}
                      />
                    </Form.Group>
                    <Form.Group>
                      <Form.Label>Gestor CAV</Form.Label>
                      <Selector
                        noOptionsMessage={() => 'Nenhum gestor encontrado'}
                        placeholder="Selecione um gestor..."
                        options={gestoresDisponiveis || []}
                        onChange={option => {
                          setFieldValue(
                            'codigo_atendente_cav',
                            option ? option.value : ''
                          );
                        }}
                        name="codigo_atendente_cav"
                        isLoading={
                          !gestoresDisponiveis ||
                          gestoresDisponiveis.length === 0
                        }
                        value={
                          gestoresDisponiveis.find(
                            g => g.value === values.codigo_atendente_cav
                          ) || null
                        }
                        isClearable
                        isDisabled={isSubmitting}
                        styles={customStyles}
                        components={{ DropdownIndicator }}
                      />
                    </Form.Group>
                    <Form.Group>
                      <Form.Label>Justificativa *</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows="3"
                        placeholder="Informe um motivo..."
                        name="justificativa"
                        onChange={handleChange}
                        disabled={isSubmitting || !!justificativaPadrao}
                        required
                        value={justificativaPadrao || values.justificativa}
                      />
                    </Form.Group>
                    {isSubmitting && (
                      <Loading label="Atribuindo etapa aos prospectos..." />
                    )}
                    {!isSubmitting && (
                      <Form.Group className="text-center">
                        <Button
                          variant="outline-success"
                          type="submit"
                          className="ml-auto"
                          disabled={
                            isSubmitting ||
                            (!values.codigo_etapa &&
                              !values.codigo_atendente_cav) ||
                            (!justificativaPadrao &&
                              (!values.justificativa ||
                                values.justificativa.trim() === ''))
                          }
                        >
                          <FiSave />
                          <span>
                            &nbsp;Atribuir a {codigosProspectos.length}{' '}
                            Prospecto(s)
                          </span>
                        </Button>
                      </Form.Group>
                    )}
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          )}
        </Formik>
      );
    }

    if (modoSimplificado && codigosProspectos) {
      return (
        <Formik
          onSubmit={this.atribuirProspectos}
          initialValues={{
            codigo_atendente_cav: '',
            justificativa: justificativaPadrao || '',
            vinculos: codigosProspectos.map(codigo => `${codigo}|0`),
          }}
        >
          {({
            handleSubmit,
            values,
            handleChange,
            setFieldValue,
            isSubmitting,
          }) => (
            <Col>
              <Card>
                <Card.Body>
                  <Form onSubmit={handleSubmit}>
                    <Form.Group>
                      <Form.Label>Atendente CAV</Form.Label>
                      <Selector
                        noOptionsMessage={() => 'Nenhum atendente encontrado'}
                        placeholder="Selecione um atendente..."
                        options={gestoresDisponiveis}
                        onChange={option => {
                          setFieldValue(
                            'codigo_atendente_cav',
                            option ? option.value : ''
                          );
                        }}
                        name="codigo_atendente_cav"
                        isLoading={
                          !gestoresDisponiveis ||
                          gestoresDisponiveis.length === 0
                        }
                        value={
                          gestoresDisponiveis.find(
                            g => g.value === values.codigo_atendente_cav
                          ) || null
                        }
                        isClearable
                        isDisabled={isSubmitting}
                        styles={customStyles}
                        components={{ DropdownIndicator }}
                      />
                    </Form.Group>

                    <Form.Group>
                      <Form.Label>Justificativa</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows="3"
                        placeholder="Informe um motivo..."
                        name="justificativa"
                        onChange={handleChange}
                        disabled={isSubmitting || !!justificativaPadrao}
                        required
                        value={justificativaPadrao || values.justificativa}
                      />
                    </Form.Group>

                    {isSubmitting && (
                      <Loading label="Atribuindo prospectos..." />
                    )}
                    {!isSubmitting && (
                      <Form.Group className="text-center">
                        <Button
                          variant="outline-success"
                          type="submit"
                          className="ml-auto"
                          disabled={
                            isSubmitting || !values.codigo_atendente_cav
                          }
                        >
                          <FiSave />
                          <span>
                            &nbsp;Atribuir {codigosProspectos.length}{' '}
                            Prospecto(s)
                          </span>
                        </Button>
                      </Form.Group>
                    )}
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          )}
        </Formik>
      );
    }

    return (
      <>
        {!hideHeader && <Header title="Atribuir Prospectos" />}

        {!prospectos && !codigo_prospecto && !codigosProspectos && (
          <Formik
            onSubmit={this.buscarProspectos}
            initialValues={{
              codigo_empreendimento: null,
              prospectos_buscar: null,
            }}
          >
            {({
              handleSubmit,
              values,
              handleChange,
              setFieldValue,
              isSubmitting,
            }) => (
              <Col>
                <Card>
                  <Card.Body>
                    <Form onSubmit={handleSubmit}>
                      {!prospectos && (
                        <>
                          {!isLoadingOptions && (
                            <Form.Group controlId="search.codigo_empreendimento">
                              <Selector
                                noOptionsMessage={() =>
                                  'Nenhum empreendimentos encontrado'
                                }
                                placeholder="Pesquisar empreendimentos..."
                                options={optionsEmpreendimentos}
                                onChange={option => {
                                  setFieldValue(
                                    'codigo_empreendimento',
                                    option.value
                                  );
                                }}
                                name="codigo_empreendimento"
                                isLoading={isLoadingOptions || isSubmitting}
                                value={this.buildValueEmpreendimento(
                                  values.codigo_empreendimento
                                )}
                              />
                            </Form.Group>
                          )}
                          <Form.Group>
                            <Form.Control
                              as="textarea"
                              rows="3"
                              name="codigos_prospectos"
                              onChange={handleChange}
                              disabled={isSubmitting}
                              required
                              placeholder="Informe um ou mais prospectos..."
                            />
                          </Form.Group>

                          <Form.Group className="text-center">
                            <Button
                              variant="outline-primary"
                              type="submit"
                              className="ml-auto"
                              disabled={isSubmitting}
                            >
                              <FaSearch />
                              <span> Buscar</span>
                            </Button>
                          </Form.Group>
                        </>
                      )}
                    </Form>
                  </Card.Body>
                </Card>
              </Col>
            )}
          </Formik>
        )}

        {prospectos && (
          <Formik
            onSubmit={this.atribuirProspectos}
            initialValues={{
              acao: '',
              vinculos:
                prospectos.length === 1
                  ? [
                    `${prospectos[0].codigo_prospecto}|${prospectos[0].codigo_familia}`,
                  ]
                  : [],
            }}
          >
            {({
              handleSubmit,
              values,
              handleChange,
              setFieldValue,
              isSubmitting,
            }) => (
              <>
                <Col>
                  <Card>
                    <Card.Body>
                      <Form onSubmit={handleSubmit}>
                        {!codigo_prospecto && !codigosProspectos && (
                          <Form.Group className="text-center">
                            <Button
                              variant="outline-primary"
                              type="submit"
                              className="ml-auto"
                              onClick={this.onClickNovaBusca}
                              disabled={isSubmitting}
                            >
                              <FaSearch />
                              <span>&nbsp;Nova Busca</span>
                            </Button>
                          </Form.Group>
                        )}

                        <p className="text-center">
                          Selecione os prospectos, informe uma justificativa e
                          execute a ação desejada
                        </p>

                        {podeGerenciarSetclub && (
                          <Form.Group>
                            <Form.Label>Ação SetClube</Form.Label>
                            <Selector
                              noOptionsMessage={() => 'Nenhuma ação encontrada'}
                              placeholder="Selecione uma ação SetClube..."
                              options={ACOES_SETCLUB_OPTIONS}
                              onChange={option => {
                                setFieldValue(
                                  'acao',
                                  option ? option.value : ''
                                );
                                if (option) {
                                  setFieldValue('codigo_gerente', '');
                                  setFieldValue('codigo_corretor', '');
                                }
                              }}
                              name="acao"
                              isLoading={isSubmitting}
                              value={
                                ACOES_SETCLUB_OPTIONS.find(
                                  item => item.value === values.acao
                                ) || null
                              }
                              isClearable
                              isDisabled={isSubmitting}
                              styles={customStyles}
                              components={{ DropdownIndicator }}
                            />
                          </Form.Group>
                        )}

                        {this.isAcaoSetclub(values.acao) && (
                          <div className="alert alert-info">
                            {values.acao === ACOES_MASSA.ATRIBUIR_SETCLUB
                              ? `Os ${values.vinculos.length} prospecto(s) selecionado(s) serão marcados como SetClube.`
                              : `Os ${values.vinculos.length} prospecto(s) selecionado(s) deixarão de ser SetClube.`}
                          </div>
                        )}

                        {!this.isAcaoSetclub(values.acao) && (
                          <SelectGerenteCorretor
                            gerente={values.codigo_gerente}
                            corretor={values.codigo_corretor}
                            onChangeGerente={gerente =>
                              setFieldValue('codigo_gerente', gerente)
                            }
                            onChangeCorretor={corretor =>
                              setFieldValue('codigo_corretor', corretor)
                            }
                            ColSizeMd={6}
                          />
                        )}

                        <Form.Group>
                          <Form.Control
                            as="textarea"
                            rows="3"
                            placeholder="Informe um motivo..."
                            name="justificativa"
                            onChange={handleChange}
                            disabled={isSubmitting || justificativaPadrao}
                            required
                            value={justificativaPadrao || values.justificativa}
                          />
                        </Form.Group>

                        <Table striped bordered hover responsive>
                          <thead>
                            <tr>
                              <th className="text-center">
                                <label
                                  htmlFor="all"
                                  className="cursor-pointer mb-0"
                                >
                                  <input
                                    className="mr-2"
                                    id="all"
                                    type="checkbox"
                                    checked={
                                      values.vinculos &&
                                      values.vinculos.length ===
                                      prospectos.length
                                    }
                                    onChange={() =>
                                      setFieldValue(
                                        'vinculos',
                                        this.selecionaTodosProspectos(
                                          values.vinculos,
                                          prospectos
                                        )
                                      )
                                    }
                                  />
                                  Atribuir
                                </label>
                              </th>
                              <th>Prospecto</th>
                              <th>Empreendimento</th>
                              <th>Gerente</th>
                              <th>Corretor</th>
                              <th>Imobiliária</th>
                            </tr>
                          </thead>
                          <tbody>
                            {prospectos.map((prospecto, index) => {
                              const isSetclub =
                                prospecto.is_setclub ||
                                (prospecto.prospecto &&
                                  prospecto.prospecto.is_setclub);

                              return (
                              <tr
                                key={index}
                                style={
                                  isSetclub
                                    ? { backgroundColor: '#ecfeff' }
                                    : {}
                                }
                              >
                                <td>
                                  <Form.Check
                                    checked={
                                      values.vinculos &&
                                      values.vinculos.includes(
                                        `${prospecto.codigo_prospecto}|${prospecto.codigo_familia}`
                                      )
                                    }
                                    onChange={() => {
                                      let id = `${prospecto.codigo_prospecto}|${prospecto.codigo_familia}`;
                                      if (
                                        values.vinculos &&
                                        values.vinculos.includes(id)
                                      ) {
                                        values.vinculos.splice(
                                          values.vinculos.indexOf(id),
                                          1
                                        );
                                      } else {
                                        values.vinculos.push(id);
                                      }
                                      setFieldValue(
                                        'vinculos',
                                        values.vinculos
                                      );
                                    }}
                                  />
                                </td>
                                <td>
                                  {prospecto.prospecto.nome}
                                  {isSetclub && (
                                    <span
                                      className="d-inline-block ml-2"
                                      style={{
                                        backgroundColor: '#ccfbf1',
                                        border: '1px solid #0f766e',
                                        borderRadius: 4,
                                        color: '#0f3f3a',
                                        fontSize: 11,
                                        fontWeight: 700,
                                        padding: '1px 6px',
                                      }}
                                    >
                                      SetClube
                                    </span>
                                  )}
                                </td>
                                <td>{prospecto.empreendimento.descricao}</td>
                                <td>{prospecto.gerente.nome}</td>
                                <td>{prospecto.corretor.nome}</td>
                                <td
                                  className="text-center font-weight-bold"
                                  style={{ color: prospecto.imobiliaria.cor }}
                                >
                                  {prospecto.imobiliaria.nome}
                                </td>
                              </tr>
                              );
                            })}
                          </tbody>
                        </Table>

                        {isSubmitting && (
                          <Loading
                            label={
                              this.isAcaoSetclub(values.acao)
                                ? 'Atualizando SetClube dos prospectos...'
                                : 'Atribuindo prospectos...'
                            }
                          />
                        )}
                        {!isSubmitting && (
                          <Form.Group className="text-center">
                            <Button
                              variant="outline-success"
                              type="submit"
                              className="ml-auto"
                              disabled={
                                isSubmitting ||
                                !values.vinculos ||
                                values.vinculos.length === 0 ||
                                (!this.isAcaoSetclub(values.acao) &&
                                  (!values.codigo_corretor ||
                                    !values.codigo_gerente))
                              }
                            >
                              <FiSave />
                              <span>
                                &nbsp;
                                {this.isAcaoSetclub(values.acao)
                                  ? 'Atualizar SetClube'
                                  : 'Atribuir Prospectos'}
                              </span>
                            </Button>
                          </Form.Group>
                        )}
                      </Form>
                    </Card.Body>
                  </Card>
                </Col>
              </>
            )}
          </Formik>
        )}
      </>
    );
  }
}

const mapStateToProps = state => ({
  empreendimentos: state.empreendimentos,
  isLoadingOptions: state.prospecto.is_loading_options,
});

export default connect(mapStateToProps)(withRouter(AtribuirProspectos));
